<script setup lang="ts">
import { RouterLink } from 'vue-router';
import { useAuthUser, useGlobals } from '@/helpers/globals';

const globals = useGlobals();
const user = useAuthUser();
</script>

<template>
    <main>
        <div class="welcome-container">
            <div class="welcome-text ktg-title-01">
                <div v-html="$t('welcome_to_eplan')"></div>
            </div>
            <div v-if="!globals.show_under_development_info" class="buttoncontainer">
                <div class="col">
                    <RouterLink :to="{ name: 'planungsgeschaefte-overview' }">
                        <ktg-button class="w-18rem" appearance="primary" leading-icon="document">
                            {{ $t('create_new_geschaeft') }}
                        </ktg-button>
                    </RouterLink>
                </div>
                <div class="col">
                    <RouterLink :to="{ name: 'planungsgeschaefte-my-geschaefte' }">
                        <ktg-button appearance="secondary" leading-icon="edit-pen" class="w-18rem">
                            {{ $t('edit_planungsgeschaeft') }}
                        </ktg-button>
                    </RouterLink>
                </div>
            </div>
        </div>

        <div v-if="!globals.show_under_development_info" class="offer-container">
            <div class="ktg-main-container mt-3rem px-2_5rem">
                <div class="mb-5rem">
                    <h2 class="ktg-title-02">{{ $t('our_offer') }}</h2>
                </div>
                <div class="mb-0_5rem offer-grid">
                    <div>
                        <h5 class="ktg-title-05 mb-1_5rem">{{ $t('neues_planungsgeschaeft_erfassen') }}</h5>
                        <p class="ktg-body">
                            {{ $t('erfassen_sie_ihr_planungsgeschaeft_elektronisch') }}
                        </p>
                        <p class="mt-1rem">
                            <RouterLink
                                :to="{ name: 'planungsgeschaefte-overview' }"
                                custom
                                v-slot="{ href, navigate }"
                            >
                                <ktg-link :href="href" @click="navigate" trailing-icon="">{{
                                    $t('create_new_geschaeft')
                                }}</ktg-link>
                            </RouterLink>
                        </p>
                    </div>
                    <div>
                        <h5 class="ktg-title-05 mb-1_5rem">{{ $t('fortschritt_verfolgen') }}</h5>
                        <p class="ktg-body">
                            {{ $t('fortschritt_verfolgen_info_text') }}
                        </p>
                        <p class="mt-1rem">
                            <RouterLink
                                :to="{ name: 'planungsgeschaefte-my-geschaefte' }"
                                custom
                                v-slot="{ href, navigate }"
                            >
                                <ktg-link :href="href" @click="navigate" trailing-icon="">{{
                                    $t('zur_uebersicht')
                                }}</ktg-link>
                            </RouterLink>
                        </p>
                    </div>
                    <div>
                        <h5 class="ktg-title-05 mb-1_5rem">{{ $t('hilfe_amp_kontakt') }}</h5>
                        <p class="ktg-body">
                            {{ $t('hilfe_kontakt_info_text') }}
                        </p>
                        <p class="mt-1rem">
                            <RouterLink :to="{ name: 'help-faq' }" custom v-slot="{ href, navigate }">
                                <ktg-link :href="href" @click="navigate" trailing-icon="">{{
                                    $t('zu_hilfe_kontakt')
                                }}</ktg-link>
                            </RouterLink>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<style scoped lang="scss">
.welcome-container {
    position: relative;
    z-index: 2;
    // background-image: url(@/assets/images/worker.svg);
    background-repeat: no-repeat;
    background-position: bottom;
    background-size: contain;
    height: 450px;
    margin-top: 2rem;

    @media (max-width: 670px) {
        background-size: 250%;
        background-position-x: -30px;
        margin-top: 0rem;
        height: clamp(300px, 150vw, 650px);
    }

    .welcome-text {
        text-align: center;
    }

    .buttoncontainer {
        margin-top: 4.5rem;
        display: grid;
        justify-content: center;
        grid-row-gap: 1rem;
        @media (max-width: 670px) {
            margin-top: 2rem;
        }
    }
}

.offer-container {
    position: relative;
    z-index: 1;
    margin-top: -48px;
    padding-top: 120px;
    padding-bottom: 120px;
    background-color: var(--ktg-color-brand2-01);
}

.offer-grid {
    display: grid;
    grid-row-gap: 2rem;
    grid-template-columns: repeat(auto-fit, minmax(12.5rem, 27rem));
}
</style>
